import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PassportInfo from './PassportInfo';

DocumentInfoCountry.propTypes = {};

function DocumentInfoCountry({ documentInfo }) {
  const { passport } = documentInfo;
  const { t } = useTranslation();

  return (
    <Box marginY={1.5}>
      <PassportInfo passportInfo={passport} title={t('passport')} />
    </Box>
  );
}

export default DocumentInfoCountry;
